export default __webpack_public_path__ + "static/entertainment-fade-in-97f85838cde9ded1224c8dd78f568baf.gif";